// extracted by mini-css-extract-plugin
export default {"chat-window":"NotificationWindowV1_chat-window__tO0s8"};